import { __ANY_CTA } from 'customer-data-filters-ui/converters/listSegClassic/ListSegConstants';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'atom... Remove this comment to see the full error message
import { deref, unwatch, watch } from 'atom';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { isResolved } from 'reference-resolvers/utils';
import FilterOperatorType from 'customer-data-filters-ui/components/propTypes/FilterOperatorType';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import get from 'transmute/get';
import indexBy from 'transmute/indexBy';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
export default class DisplayValueCta extends PureComponent {
  constructor() {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1-2 arguments, but got 0.
    super();
    this.handleReferenceChange = reference => {
      const {
        value
      } = this.props;
      if (isResolved(reference)) {
        const ctas = indexBy(
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '<T extends object | Iterable<any... Remove this comment to see the full error message
        get('guid'), reference.referencedObject.get('ctaInfo'));
        const label = ctas.getIn([value, 'label']) ? ctas.getIn([value, 'label']) : I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.variationCta.display', {
          variantLabel: ctas.getIn([value, 'variantLabel'])
        });
        const isDefault = ctas.getIn([value, 'isDefault']);
        this.setState({
          reference: isDefault ? I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.defaultCta.display') : label
        });
      }
    };
    this.state = {
      reference: null
    };
    this.referenceAtom = null;
  }
  componentDidMount() {
    this.getReference();
  }
  componentDidUpdate(prevProps) {
    var _operator$field, _prevOperator$field;
    const {
      operator
    } = this.props;
    const prevOperator = prevProps.operator;
    if (((_operator$field = operator.field) === null || _operator$field === void 0 ? void 0 : _operator$field.name) !== ((_prevOperator$field = prevOperator.field) === null || _prevOperator$field === void 0 ? void 0 : _prevOperator$field.name) || operator.value !== prevOperator.value) {
      this.getReference();
    }
  }
  componentWillUnmount() {
    if (this.referenceAtom) {
      unwatch(this.referenceAtom, this.handleReferenceChange);
    }
  }
  getReference() {
    var _operator$field2;
    const {
      getFamilyValueResolver,
      operator,
      value
    } = this.props;
    const resolver = getFamilyValueResolver(operator);
    if (value !== __ANY_CTA && resolver && typeof resolver.byId !== 'function') {
      Raven.captureException(new Error(`[Expected a reference resolver] resolver does not have 'byId' function; operator.field: ${JSON.stringify(operator.field)}`));
    }
    if (value === __ANY_CTA) {
      this.setState({
        reference: value
      });
    } else if (resolver && resolver.byId && ((_operator$field2 = operator.field) === null || _operator$field2 === void 0 ? void 0 : _operator$field2.name) !== 'undefined') {
      var _operator$field3;
      if (this.referenceAtom) {
        unwatch(this.referenceAtom, this.handleReferenceChange);
      }
      this.referenceAtom = resolver.byId((_operator$field3 = operator.field) === null || _operator$field3 === void 0 ? void 0 : _operator$field3.name);
      watch(this.referenceAtom, this.handleReferenceChange);
      this.handleReferenceChange(deref(this.referenceAtom));
    }
  }
  getValueName() {
    const {
      reference
    } = this.state;
    if (reference === __ANY_CTA) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.anyCta.display"
      });
    }
    return reference;
  }
  render() {
    return /*#__PURE__*/_jsx("span", {
      children: this.getValueName()
    });
  }
}
DisplayValueCta.propTypes = {
  getFamilyValueResolver: PropTypes.func.isRequired,
  operator: FilterOperatorType.isRequired,
  value: PropTypes.string.isRequired
};